export default "__VITE_ASSET__DgQ$IJfb__"